import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vShow as _vShow, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("주문/결제하기")
const _hoisted_3 = {
  id: "content",
  class: "content"
}
const _hoisted_4 = { class: "payment_order" }
const _hoisted_5 = { class: "box_order_card" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h2", { class: "tit" }, "주문 상품", -1)
const _hoisted_7 = {
  class: "card_in",
  href: "#"
}
const _hoisted_8 = { class: "thumb" }
const _hoisted_9 = { class: "cont" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = { class: "price" }
const _hoisted_12 = { class: "order_count" }
const _hoisted_13 = { class: "box_recipient" }
const _hoisted_14 = { class: "tit" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("받는 사람 ")
const _hoisted_16 = {
  key: 0,
  class: "unit"
}
const _hoisted_17 = { class: "list_recipient" }
const _hoisted_18 = { class: "recipients" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "point_area" }
const _hoisted_21 = { class: "tit_area" }
const _hoisted_22 = /*#__PURE__*/_createVNode("h2", { class: "tit" }, "포인트", -1)
const _hoisted_23 = { class: "hold_point" }
const _hoisted_24 = { class: "input_area" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", {
  for: "input_point",
  class: "blind"
}, "보유 포인트", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "ico_del" }, [
  /*#__PURE__*/_createVNode("span", { class: "blind" }, "지우기")
], -1)
const _hoisted_27 = { class: "charge_area" }
const _hoisted_28 = { class: "tit_area" }
const _hoisted_29 = /*#__PURE__*/_createVNode("h2", { class: "tit" }, "충전금", -1)
const _hoisted_30 = { class: "hold_money" }
const _hoisted_31 = { class: "input_area" }
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "ico_del" }, [
  /*#__PURE__*/_createVNode("span", { class: "blind" }, "지우기")
], -1)
const _hoisted_33 = { class: "payment_info_area" }
const _hoisted_34 = { class: "box_payment_info" }
const _hoisted_35 = /*#__PURE__*/_createVNode("h2", { class: "tit" }, "결제 정보", -1)
const _hoisted_36 = { class: "txt_area" }
const _hoisted_37 = /*#__PURE__*/_createVNode("p", { class: "txt" }, "상품 금액", -1)
const _hoisted_38 = { class: "price" }
const _hoisted_39 = { class: "txt_area" }
const _hoisted_40 = /*#__PURE__*/_createVNode("p", { class: "txt" }, "총 수량", -1)
const _hoisted_41 = { class: "number" }
const _hoisted_42 = { class: "txt_area" }
const _hoisted_43 = /*#__PURE__*/_createVNode("p", { class: "txt" }, "포인트 사용", -1)
const _hoisted_44 = { class: "price" }
const _hoisted_45 = { class: "txt_area" }
const _hoisted_46 = /*#__PURE__*/_createVNode("p", { class: "txt" }, "충전금 사용", -1)
const _hoisted_47 = { class: "price" }
const _hoisted_48 = { class: "box_order_amount" }
const _hoisted_49 = { class: "box_total" }
const _hoisted_50 = /*#__PURE__*/_createVNode("strong", { class: "total_title" }, "총 결제 금액", -1)
const _hoisted_51 = { class: "total_price" }
const _hoisted_52 = { class: "num" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("원")
const _hoisted_54 = { class: "box_payment_method" }
const _hoisted_55 = /*#__PURE__*/_createVNode("h2", { class: "tit" }, "결제 수단", -1)
const _hoisted_56 = { class: "radio_group" }
const _hoisted_57 = { class: "radio_area" }
const _hoisted_58 = /*#__PURE__*/_createVNode("label", {
  class: "inp_label logo_payco",
  for: "rdo1_1"
}, "페이코", -1)
const _hoisted_59 = { class: "radio_area" }
const _hoisted_60 = /*#__PURE__*/_createVNode("label", {
  class: "inp_label",
  for: "rdo1_2"
}, "신용/체크카드", -1)
const _hoisted_61 = { class: "radio_area" }
const _hoisted_62 = /*#__PURE__*/_createVNode("label", {
  class: "inp_label",
  for: "rdo1_3"
}, "휴대폰 결제", -1)
const _hoisted_63 = { class: "policy_area" }
const _hoisted_64 = { class: "checkbox" }
const _hoisted_65 = /*#__PURE__*/_createVNode("label", {
  class: "checkbox_lbl",
  for: "chk_agree2"
}, "취소/환불 규정에 동의합니다.", -1)
const _hoisted_66 = { class: "btn_area_wrap" }
const _hoisted_67 = { class: "btn_area" }
const _hoisted_68 = {
  class: "dimmed",
  style: {"display":"block"}
}
const _hoisted_69 = {
  class: "layer terms_agree terms_refund",
  style: {"display":"block"}
}
const _hoisted_70 = /*#__PURE__*/_createStaticVNode("<div class=\"layer_tit\"><strong>교환권 구매 전 취소/환불 규정 동의</strong></div><p class=\"layer_desc\">구매하신 교환권 취소/환불을 원하실 경우 <br>다음 내용을 참고해주세요.</p><div class=\"layer_cont\"><div class=\"terms_item\"><em class=\"item_tit\">[교환권 취소]</em><ul class=\"type_hyphen\"><li>- 교환권 취소는 발행일(결제일)로부터 최대 7일 내 구매자의 요청에 의해 가능하며, 최초결제금액의 100% 환불 가능합니다.</li><li>- 구매 시 결제한 원결제 수단으로 주문 취소 가능하고, 부분결제 취소는 불가하오니 결제 전 반드시 확인해 주시기 바랍니다.</li><li>- 교환권 취소 불가능한 경우 : 이미 사용된 교환권에 대해서는 취소/환불 불가</li><li>- 프로모션 상품, 사은품, 이벤트 경품 등을 통해 무상으로 받은 교환권은 주문취소 대상이 아닙니다.</li><li>- 미성년자인 회원이 상품 등을 구매 시 법정대리인이 해당 계약에 대하여 동의를 하여야 정상적인 상품 등의 구매계약이 체결될 수 있습니다.</li></ul></div><div class=\"terms_item\"><em class=\"item_tit\">[환불 조건 및 요청 방법]</em><ul class=\"type_hyphen\"><li>- 환불 조건 : 발행일로부터 93일의 유효기간이 만료된 교환권에 대해서는 발행일로부터 5년 내에 환불 신청이 가능합니다.</li><li>- 환불 비용 부담 안내 : 발행일로부터 93일의 유효기간 만료 후 결제금액의 90% 환불 처리</li><li>- 환불 요청 방법 : 아티제 앱內 기프트샵에서 직접 신청 또는 고객센터를 통해 요청할 수 있습니다. <ul><li>1) 아티제 앱&gt;기프트샵 받은 선물 상세 화면&gt;환불요청</li><li>2) 아티제 고객센터&gt;환불요청</li></ul></li><li>- 아티제 고객센터 02-2155-5777 (평일 9~18시, 주말·공휴일 휴무)</li></ul></div></div>", 3)
const _hoisted_73 = { class: "btn_agree_area" }
const _hoisted_74 = { class: "txt" }
const _hoisted_75 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" 사용 가능합니다.")
const _hoisted_77 = { class: "txt" }
const _hoisted_78 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" 사용 가능합니다.")
const _hoisted_80 = { class: "layer_pop toast" }
const _hoisted_81 = /*#__PURE__*/_createVNode("p", { class: "text" }, "사용 가능한 금액을 초과하였습니다.", -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("strong", { class: "txt" }, "보유 충전카드가 없습니다.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")
  const _component_popup_component = _resolveComponent("popup-component")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      id: "wrap",
      class: [{app_view: _ctx.isApp}, "wrap"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_header_component, null, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("a", _hoisted_7, [
              _createVNode("span", _hoisted_8, [
                _createVNode("img", {
                  src: _ctx.product.productImageUrl,
                  alt: ""
                }, null, 8, ["src"])
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("strong", _hoisted_10, _toDisplayString(_ctx.product.productName), 1),
                _createVNode("p", _hoisted_11, _toDisplayString(_ctx.product.commaSalePrice) + "원", 1),
                _createVNode("span", _hoisted_12, "수량 : " + _toDisplayString(_ctx.sumOfGiftCount) + "개", 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("h2", _hoisted_14, [
              _hoisted_15,
              (_ctx.isForPresent)
                ? (_openBlock(), _createBlock("span", _hoisted_16, "(총 " + _toDisplayString(_ctx.receivers.length) + "명)", 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("ul", _hoisted_17, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.receivers, (receiver) => {
                return (_openBlock(), _createBlock("li", {
                  key: receiver.phoneNumber,
                  class: "cont_item"
                }, [
                  _createVNode("p", _hoisted_18, _toDisplayString(receiver.displayedName), 1),
                  _createVNode("p", _hoisted_19, _toDisplayString(receiver.ticketCount) + "개", 1)
                ]))
              }), 128))
            ])
          ]),
          _withDirectives(_createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode("span", _hoisted_23, _toDisplayString(_ctx.commaPointAmount) + "원 보유", 1)
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode("div", {
                class: ["input_inner", {'active': _ctx.hasInputPointAmount}]
              }, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  placeholder: "0원",
                  id: "input_point",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pointUseAmountStr = $event)),
                  onInput: _cache[2] || (_cache[2] = (e)=>_ctx.pointUseAmountStr=_ctx.changeNum(e.target.value)),
                  onFocusin: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.initInputStatus && _ctx.initInputStatus(...args))),
                  onFocusout: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.checkPointValidityForFocusOut && _ctx.checkPointValidityForFocusOut(...args))),
                  onKeyup: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.checkPointValidityForEnterKey && _ctx.checkPointValidityForEnterKey(...args)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.pointUseAmountStr]
                ]),
                _hoisted_25,
                _createVNode("button", {
                  type: "button",
                  class: "del",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clearPointUseAmount && _ctx.clearPointUseAmount(...args)))
                }, [
                  _hoisted_26
                ])
              ], 2),
              _createVNode("button", {
                type: "button",
                class: "btn_s",
                id: "all_use",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.useMaximumPoint()))
              }, "모두 사용")
            ])
          ], 512), [
            [_vShow, !_ctx.isNonMemberLogin]
          ]),
          _withDirectives(_createVNode("div", _hoisted_27, [
            _createVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode("span", _hoisted_30, _toDisplayString(_ctx.commaChargeCardAmount) + "원 보유", 1)
            ]),
            _createVNode("div", _hoisted_31, [
              _createVNode("div", {
                class: ["input_inner", {'active': _ctx.chargeCardUseAmount>0}]
              }, [
                _createVNode("span", {
                  class: ["input_charge", {'on': _ctx.chargeCardUseAmount>0}]
                }, _toDisplayString(_ctx.commaChargeCardUseAmount) + "원", 3),
                _createVNode("button", {
                  type: "button",
                  class: "del",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedChargeCardList && _ctx.clearSelectedChargeCardList(...args)))
                }, [
                  _hoisted_32
                ])
              ], 2),
              _createVNode("button", {
                type: "button",
                class: "btn_s",
                id: "reference",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.goToChargeCardSelectionPage && _ctx.goToChargeCardSelectionPage(...args)))
              }, "조회")
            ])
          ], 512), [
            [_vShow, !_ctx.isNonMemberLogin]
          ]),
          _createVNode("div", _hoisted_33, [
            _createVNode("div", _hoisted_34, [
              _hoisted_35,
              _createVNode("div", _hoisted_36, [
                _hoisted_37,
                _createVNode("span", _hoisted_38, _toDisplayString(_ctx.product.commaSalePrice) + "원", 1)
              ]),
              _createVNode("div", _hoisted_39, [
                _hoisted_40,
                _createVNode("span", _hoisted_41, _toDisplayString(_ctx.sumOfGiftCount) + "개", 1)
              ]),
              _withDirectives(_createVNode("div", _hoisted_42, [
                _hoisted_43,
                _createVNode("span", _hoisted_44, " - " + _toDisplayString(_ctx.commaPointUseAmount) + "원", 1)
              ], 512), [
                [_vShow, _ctx.pointUseAmount>=this.minimumPointAmount]
              ]),
              _withDirectives(_createVNode("div", _hoisted_45, [
                _hoisted_46,
                _createVNode("span", _hoisted_47, "- " + _toDisplayString(_ctx.commaChargeCardUseAmount) + "원", 1)
              ], 512), [
                [_vShow, _ctx.chargeCardUseAmount>0]
              ])
            ]),
            _createVNode("div", _hoisted_48, [
              _createVNode("div", _hoisted_49, [
                _hoisted_50,
                _createVNode("span", _hoisted_51, [
                  _createVNode("span", _hoisted_52, _toDisplayString(_ctx.commaTotalPrice), 1),
                  _hoisted_53
                ])
              ])
            ])
          ]),
          _withDirectives(_createVNode("div", _hoisted_54, [
            _hoisted_55,
            _createVNode("div", _hoisted_56, [
              _createVNode("span", _hoisted_57, [
                _withDirectives(_createVNode("input", {
                  id: "rdo1_1",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.paymentMethod = $event)),
                  class: "inp_radio",
                  type: "radio",
                  value: "PAYCO"
                }, null, 512), [
                  [_vModelRadio, _ctx.paymentMethod]
                ]),
                _hoisted_58
              ]),
              _createVNode("span", _hoisted_59, [
                _withDirectives(_createVNode("input", {
                  id: "rdo1_2",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.paymentMethod = $event)),
                  class: "inp_radio",
                  type: "radio",
                  value: "CREDIT_CARD"
                }, null, 512), [
                  [_vModelRadio, _ctx.paymentMethod]
                ]),
                _hoisted_60
              ]),
              _createVNode("span", _hoisted_61, [
                _withDirectives(_createVNode("input", {
                  id: "rdo1_3",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.paymentMethod = $event)),
                  class: "inp_radio",
                  type: "radio",
                  value: "PHONE"
                }, null, 512), [
                  [_vModelRadio, _ctx.paymentMethod]
                ]),
                _hoisted_62
              ])
            ])
          ], 512), [
            [_vShow, _ctx.totalPrice > 0]
          ]),
          _createVNode("div", _hoisted_63, [
            _createVNode("div", {
              class: ["box_terms", { pay_disabled : _ctx.totalPrice <= 0}]
            }, [
              _createVNode("div", _hoisted_64, [
                _withDirectives(_createVNode("input", {
                  id: "chk_agree2",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.personalInformationConsent = $event)),
                  class: "checkbox_inp",
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.personalInformationConsent]
                ]),
                _hoisted_65,
                _createVNode("button", {
                  class: "btn_more",
                  type: "button",
                  onClick: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleConsentPopup && _ctx.toggleConsentPopup(...args)), ["prevent"]))
                }, "보기")
              ])
            ], 2)
          ]),
          _createVNode("div", _hoisted_66, [
            _createVNode("div", _hoisted_67, [
              _createVNode("button", {
                type: "button",
                class: ["btn btn_full", {'is_inactive': !_ctx.canPay}],
                disabled: !_ctx.canPay,
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.orderProduct && _ctx.orderProduct(...args)))
              }, "결제하기", 10, ["disabled"])
            ])
          ])
        ])
      ])
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_68, null, 512), [
      [_vShow, _ctx.isDimmedCondition]
    ]),
    _withDirectives(_createVNode("div", _hoisted_69, [
      _hoisted_70,
      _createVNode("div", _hoisted_73, [
        _createVNode("button", {
          class: "btn btn_confirm",
          type: "button",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.personalInformationConsent=true, _ctx.toggleConsentPopup()))
        }, "확인")
      ]),
      _createVNode("a", {
        class: "btn_close",
        href: "#",
        onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleConsentPopup && _ctx.toggleConsentPopup(...args)), ["prevent"]))
      }, "팝업 닫기")
    ], 512), [
      [_vShow, _ctx.consentPopup]
    ]),
    _withDirectives(_createVNode(_component_popup_component, { onConfirm: _ctx.toggleMinimumRestPointAmountPopup }, {
      default: _withCtx(() => [
        _createVNode("strong", _hoisted_74, [
          _createTextVNode("포인트는 최소 " + _toDisplayString(_ctx.commaMinimumRestPointAmount) + "원 보유 시 ", 1),
          _hoisted_75,
          _hoisted_76
        ])
      ]),
      _: 1
    }, 8, ["onConfirm"]), [
      [_vShow, _ctx.showMinimumRestPointAmountPopup]
    ]),
    _withDirectives(_createVNode(_component_popup_component, { onConfirm: _ctx.toggleMinimumPointAmountPopup }, {
      default: _withCtx(() => [
        _createVNode("strong", _hoisted_77, [
          _createTextVNode("포인트는 최소 " + _toDisplayString(_ctx.commaMinimumPointAmount) + "원부터 ", 1),
          _hoisted_78,
          _hoisted_79
        ])
      ]),
      _: 1
    }, 8, ["onConfirm"]), [
      [_vShow, _ctx.showMinimumPointAmountPopup]
    ]),
    _withDirectives(_createVNode("div", _hoisted_80, [
      _hoisted_81
    ], 512), [
      [_vShow, _ctx.showMaximumPointAmountToast]
    ]),
    _withDirectives(_createVNode(_component_popup_component, { onConfirm: _ctx.toggleNoChargeCardPopup }, {
      default: _withCtx(() => [
        _hoisted_82
      ]),
      _: 1
    }, 8, ["onConfirm"]), [
      [_vShow, _ctx.showNoChargeCardPopup]
    ])
  ], 64))
}